<div class="p-grid" *ngIf="showHeader">
    <div class="p-col-12">
        <div class="p-d-flex p-jc-between">
            <h5 class="p-ml-3">{{reportName}}</h5>
            <p class="p-mr-3">{{reportDate | date: 'short'}}</p>
        </div>
    </div>
</div>

<div class="p-grid" *ngIf="['old'].includes(selectedWindow)">
    <div class="p-col-12">
        <p-table [value]="products" responsiveLayout="scroll" [(rows)]="showRows"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [paginator]="true" [(first)]="first" dataKey="userid"
        styleClass="p-datatable-gridlines" [resizableColumns]="true">
            <ng-template pTemplate="header">
                <tr>
                    <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Rep Name</th>
                    <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Name</th>
                    <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Channel Name</th>
                    <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Total Visits</th>
                    <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Geo Matched</th>
                    <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Geo Not Matched</th>
                    <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Last Visit Date</th>
                    <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Avg. Time Spent</th>
                </tr>
            </ng-template>
            <!-- <ng-template pTemplate="body" let-data let-expanded="expanded">
                <tr>
                    <td class="action" [attr.colspan]="7">
                        <button type="button" pButton pRipple [pRowToggler]="data"
                            class="p-button-text p-button-rounded p-button-plain mr-2"
                            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                        </button>
                        <b class="p-ml-2" style="line-height: 2;">{{data.username}}</b>
                    </td>
                </tr>
            </ng-template> -->
            <ng-template pTemplate="body" let-s>
                <!-- <ng-container *ngFor="let s of data.visits"> -->
                    <tr (click)="onRowSelect(data,s)" class="cursor-pointer">
                        <td>
                            {{s?.username}}
                        </td>
                        <td>
                            {{s?.businessname}}
                        </td>
                        <td>
                            {{s?.channelname}}
                        </td>
                        <td>
                            {{s?.totalvisit}}
                        </td>
                        <td>
                            {{s?.visitedcount}}
                        </td>
                        <td>
                            {{s?.nonvisitedcount}}
                        </td>
                        <td>
                            {{s?.createddate | localDate:'MM/DD/YYYY'}}
                        </td>
                        <td>
                            {{s?.timespent | timeConvert}}
                        </td>
                    </tr>
                <!-- </ng-container> -->
            </ng-template>
        </p-table>
    </div>
</div>

<div class="p-grid" *ngIf="['old'].includes(selectedWindow)">
    <div class="p-col-12">
        <p-table [value]="products" responsiveLayout="scroll" [(rows)]="showRows"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [paginator]="true" [(first)]="first" dataKey="territoryid"
        styleClass="p-datatable-gridlines" [resizableColumns]="true">
            <ng-template pTemplate="header">
                <tr>
                    <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Territory</th>
                    <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Name</th>
                    <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Channel Name</th>
                    <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Total Visits</th>
                    <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Geo Matched</th>
                    <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Geo Not Matched</th>
                    <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Last Visit Date</th>
                    <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Avg. Time Spent</th>
                </tr>
            </ng-template>
            <!-- <ng-template pTemplate="body" let-data let-expanded="expanded">
                <tr>
                    <td class="action" [attr.colspan]="8">
                        <button type="button" pButton pRipple [pRowToggler]="data"
                            class="p-button-text p-button-rounded p-button-plain mr-2"
                            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                        </button>
                        <b class="p-ml-2" style="line-height: 2;">{{data.territoryname || 'N/A'}}</b>
                    </td>
                </tr>
            </ng-template> -->
            <ng-template pTemplate="body" let-s>
                <!-- <ng-container *ngFor="let s of data.allData"> -->
                    <tr (click)="onRowSelect(data,s)" class="{{s?.rowColor}}" [ngClass]="{'cursor-pointer': s?.businessname}">
                        <td>
                            {{s?.territoryname}}
                        </td>
                        <td>
                            {{ s?.businessname | shorten }}
                        </td>
                        <td>
                            {{s?.channelname}}
                        </td>
                        <td>
                            {{s?.totalvisit}}
                        </td>
                        <td>
                            {{s?.visitedcount}}
                        </td>
                        <td>
                            {{s?.nonvisitedcount}}
                        </td>
                        <td>
                            {{s?.createddate | localDate:'MM/DD/YYYY'}}
                        </td>
                        <td>
                            {{s?.timespent | timeConvert}}
                        </td>
                    </tr>
                <!-- </ng-container> -->
            </ng-template>
        </p-table>
    </div>
</div>

<div class="p-grid" *ngIf="[reportsVisitsNames.getterritorywiseaccountvisithistoryofrep, reportsVisitsNames.getterritorywiseleadvisithistoryofrep,reportsVisitsNames.getaccountfieldvisithistorybyrep, reportsVisitsNames.getleadfieldvisithistorybyrep, reportsVisitsNames.getterritorywiseaccountvisithistory, reportsVisitsNames.getterritorywiseleadvisithistory, reportsVisitsNames.avareagefieldvisitbyrep].includes(selectedWindow)">
    <div class="p-col-12">
        <p-table [value]="products" responsiveLayout="scroll" [(rows)]="showRows"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore" [columns]="columns"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [paginator]="true" [(first)]="first" dataKey="territoryid"
        styleClass="p-datatable-gridlines" [resizableColumns]="true">

            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let col of columns"
                    style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                        {{col.header}}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr (click)="onRowSelect(data,rowData)" class="cursor-pointer {{rowData?.rowColor}}">
                    <td *ngFor="let col of columns">
                        <ng-container  [ngSwitch]="col?.dataType">
                            <ng-container *ngSwitchCase="'datetime'">
                                {{ rowData[col.field] | localDate }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'date'">
                                {{ rowData[col.field] | date:'MM/dd/yyyy' }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'timespan'">
                                {{ rowData[col.field] | timeConvert }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'number2dp'">
                                {{ rowData[col.field] | number: '1.2-2' }}
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                {{ rowData[col.field] }}
                            </ng-container>
                        </ng-container>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<!-- <div class="p-grid" *ngIf="![reportsVisitsNames.getaccountfieldvisithistorybyrep, reportsVisitsNames.getleadfieldvisithistorybyrep,
reportsVisitsNames.getterritorywiseaccountvisithistoryofrep, reportsVisitsNames.getterritorywiseleadvisithistoryofrep,
reportsVisitsNames.getterritorywiseaccountvisithistory , reportsVisitsNames.getterritorywiseleadvisithistory]
    .includes(selectedWindow)">
    <div class="p-col-12">
        <p-card>
            <p-table [columns]="columns" [value]="products" sortField="groupName" sortMode="single" dataKey="groupName"
                rowGroupMode="subheader" groupRowsBy="groupName">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 2rem;"></th>
                        <th *ngFor="let col of columns">
                            {{col.header}}
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="groupheader" let-product let-columns="columns" let-rowIndex="rowIndex"
                    let-expanded="expanded">
                    <tr>
                        <td [attr.colspan]="columns.length + 1" class="action">
                            <button type="button" pButton pRipple [pRowToggler]="product"
                                class="p-button-text p-button-rounded p-button-plain mr-2"
                                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                                (click)="openChild(product)"></button>
                            <b class="p-ml-2" style="line-height: 2;">{{product.groupName}}</b>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="rowexpansion" let-product let-columns="columns">
                    <ng-container *ngFor="let s of product.children">
                        <tr (click)="onRowSelect(product,s)" class="cursor-pointer">
                            <td style="width: 2rem;"></td>
                            <td *ngFor="let col of columns">
                                {{s[col.field]}}
                            </td>
                        </tr>
                    </ng-container>
                </ng-template>
            </p-table>
        </p-card>
    </div>
</div> -->

<p-dialog header="Visit Details" [(visible)]="displayVisit" [modal]="true" [style]="{width: '60vw'}">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <p-table [value]="visits" responsiveLayout="scroll">
                    <ng-template pTemplate="caption">
                        <div *ngIf="[reportsVisitsNames.avareagefieldvisitbyrep].includes(selectedWindow)" class="p-d-flex p-ai-center p-jc-between">
                            <h5 class="p-mb-0">Field Visited by {{tempChild?.repName}}</h5>
                            <div class="p-d-flex p-ai-center p-text-right">
                                <p class="p-mb-0 p-mr-2">{{dateFrom | date: 'MM/dd/yyyy'}} - {{dateTo | date: 'MM/dd/yyyy'}}</p>
                                <div>
                                    <p-button (click)="openAsPDF('',tempChild?.repName)" class="p-mr-2" icon="pi pi-print"></p-button>
                                    <p-button (click)="downloadAsXLS(tempChild?.repName)" class="p-mr-2" icon="pi pi-download"></p-button>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="[reportsVisitsNames.getaccountfieldvisithistorybyrep,reportsVisitsNames.getleadfieldvisithistorybyrep].includes(selectedWindow)" class="p-d-flex p-ai-center p-jc-between">
                            <h5 class="p-mb-0">{{tempChild?.businessname}} Visited by {{tempChild?.username}}</h5>
                            <div class="p-d-flex p-ai-center p-text-right">
                                <p class="p-mb-0 p-mr-2">{{dateFrom | date: 'MM/dd/yyyy'}} - {{dateTo | date: 'MM/dd/yyyy'}}</p>
                                <div>
                                    <p-button (click)="openAsPDF(tempChild?.businessname,tempChild?.username)" class="p-mr-2" icon="pi pi-print"></p-button>
                                    <p-button (click)="downloadAsXLS(tempChild?.username)" class="p-mr-2" icon="pi pi-download"></p-button>
                                </div>
                            </div>
                        </div>
                        <div
                            *ngIf="[reportsVisitsNames.getterritorywiseaccountvisithistoryofrep, reportsVisitsNames.getterritorywiseleadvisithistoryofrep
                            , reportsVisitsNames.getterritorywiseaccountvisithistory, reportsVisitsNames.getterritorywiseleadvisithistory].includes(selectedWindow)"
                            class="p-d-flex align-items-center p-jc-between">
                            <h5 class="p-mb-0">{{tempChild?.businessname}} Visited by Rep</h5>
                            <div class="p-d-flex p-ai-center p-text-right">
                                <p class="p-mb-0  p-mr-2">{{dateFrom | date: 'MM/dd/yyyy'}} - {{dateTo | date: 'MM/dd/yyyy'}}</p>
                                <div>
                                    <p-button (click)="openAsPDF('','')" class="p-mr-2" icon="pi pi-print"></p-button>
                                    <p-button (click)="downloadAsXLS()" class="p-mr-2" icon="pi pi-download"></p-button>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th *ngIf="[reportsVisitsNames.getterritorywiseaccountvisithistoryofrep,
                                reportsVisitsNames.getterritorywiseleadvisithistoryofrep,
                                reportsVisitsNames.getterritorywiseaccountvisithistory,
                                reportsVisitsNames.getterritorywiseleadvisithistory].includes(selectedWindow)">
                                Rep Name
                            </th>
                            <th *ngIf="[reportsVisitsNames.avareagefieldvisitbyrep].includes(selectedWindow)">
                                Name
                            </th>
                            <th>Visit Date</th>
                            <th>Check In Time</th>
                            <th>Check Out Time</th>
                            <th>Check In Distance</th>
                            <th>Check Out Distance</th>
                            <th>Check Out Process</th>
                            <th>Device Info</th>
                            <th>Time Spent</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product>
                        <tr class="{{product?.rowColor}}">
                            <td *ngIf="[reportsVisitsNames.getterritorywiseaccountvisithistoryofrep,
                            reportsVisitsNames.getterritorywiseleadvisithistoryofrep,
                            reportsVisitsNames.getterritorywiseaccountvisithistory,
                            reportsVisitsNames.getterritorywiseleadvisithistory].includes(selectedWindow)">
                                {{ product?.repname }}
                            </td>
                            <td *ngIf="[reportsVisitsNames.avareagefieldvisitbyrep].includes(selectedWindow)">
                                {{ product?.businessnameGroup }}
                            </td>
                            <td> {{ product.datetime | localDate:'MM/DD/YYYY' }} </td>
                            <td> {{ product.checkintime | localDate:'h:mm a' }} </td>
                            <td> {{ product.checkouttime | localDate:'h:mm a' }} </td>
                            <td> {{ product.checkinDistance }} </td>
                            <td> {{ product.checkoutDistance }} </td>
                            <td> {{ product.checkoutProcess }} </td>
                            <td> {{ product.deviceinfo }} </td>
                            <td> {{ product.timespent ? (product.timespent | timeConvert) : '' }} </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton (click)="displayVisit=false;" label="Cancel" class="p-button-secondary"></button>
    </ng-template>
</p-dialog>
